import AppProfile from '@pages/app/appProfile';
import FeaturedApps from '@pages/app/featuredApps';
import Review from '@pages/app/review';
import PublisherProfile from '@pages/app/publisherProfile';
import Category from '@pages/app/category';

import React from 'react';
import { Routes, Route } from 'react-router-dom';

const AppRoutes: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path="/profile" element={<AppProfile />} />
        <Route path="/featured" element={<FeaturedApps />} />
        <Route path="/review" element={<Review />} />
        <Route path="/publisher" element={<PublisherProfile />} />
        <Route path="/category" element={<Category />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
